"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSQONParam = exports.stringifyJSONParam = exports.parseJSONParam = exports.parseIntParam = void 0;

var parseIntParam = function parseIntParam(str, defaults) {
  return str ? Math.max(parseInt(str, 10), 0) : defaults;
};

exports.parseIntParam = parseIntParam;

var parseJSONParam = function parseJSONParam(str, defaults) {
  if (str) {
    return JSON.parse(str) || defaults;
  } else {
    return defaults;
  }
};

exports.parseJSONParam = parseJSONParam;

var stringifyJSONParam = function stringifyJSONParam(str, defaults) {
  return str ? JSON.stringify(str) : defaults;
};

exports.stringifyJSONParam = stringifyJSONParam;
var parseSQONParam = parseJSONParam;
exports.parseSQONParam = parseSQONParam;